import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import i18n from './lang/index'; // Import i18n for language

// Import Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.css';
import 'jquery/dist/jquery.min';
import 'popper.js/dist/popper.min';
import 'bootstrap/dist/js/bootstrap.min';

// Import Axios
import axios from 'axios';
axios.defaults.withCredentials = true;

// Create Vue app and mount it
const app = createApp(App);
app.use(router);
app.use(i18n);
app.mount('#app');